import { render } from "./FeedbackPage-Form.vue?vue&type=template&id=2e4f5878"
import script from "./FeedbackPage-Form.vue?vue&type=script&lang=js"
export * from "./FeedbackPage-Form.vue?vue&type=script&lang=js"

import "./FeedbackPage-Form.vue?vue&type=style&index=0&id=2e4f5878&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__